import { Avatar, Spacer, TextCapitalized } from "@qivia/ui";
import { colors } from "@qivia/ui/src/styles/figmaColors";
import { typographies } from "@qivia/ui/src/styles/figmaTypographies";
import { useMemo } from "react";
import styled from "styled-components";

export const SessionIdentity = (props: {
  driverName: string;
  registrationNumber: string | null;
}) => {
  const initials = useMemo(
    () => props.driverName.split(" ").map((word) => word.charAt(0)),
    [props.driverName],
  );

  return (
    <StyledSessionIdentity>
      <Avatar
        size={"S"}
        color={"mint"}
        firstName={initials[0]}
        lastName={initials[initials.length - 1]}
      />
      <Spacer x={0.5} />
      <TextCapitalized>{props.driverName}</TextCapitalized>
      <Spacer x={1} />
      <TextCapitalized>{props.registrationNumber ?? "-"}</TextCapitalized>
    </StyledSessionIdentity>
  );
};

const StyledSessionIdentity = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  ${typographies["Body/XL"]}
  color: ${colors["colors/text/darkGrey"]};
`;
